import { render, staticRenderFns } from "./news.vue?vue&type=template&id=407e4320&scoped=true&"
import script from "./news.vue?vue&type=script&lang=js&"
export * from "./news.vue?vue&type=script&lang=js&"
import style0 from "./news.vue?vue&type=style&index=0&id=407e4320&prod&scoped=true&lang=scss&"
import style1 from "./news.vue?vue&type=style&index=1&id=407e4320&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407e4320",
  null
  
)

export default component.exports